module.exports = __webpack_public_path__ + "img/rank-silver.d8714ec2.png";